import angular = require("angular");
import "angular-animate";
import "angular-sanitize";
import "angular-touch";
import "ng-file-upload";
import "bootstrap";
import "angular-ui-bootstrap";
import "angular-dragdrop";
import "angular-ui-grid";
import "./Models/model";
import "ng-quill";

//'ngSanitize', 'ngFileUpload', 'ngDragDrop'
//import toastr = require("toastr");
export var directivesModule = angular.module("directives", [
	"ngAnimate",
	"ngTouch",
	"ui.bootstrap",
	"model",
	"ngDragDrop",
	"ngSanitize",
	"ngFileUpload",
	"ui.grid",
	"ui.grid.edit",
	"ui.grid.treeView",
	"ui.grid.resizeColumns",
	"ui.grid.autoResize",
	"ui.grid.cellNav",
	"ui.grid.infiniteScroll",
	"ngQuill",
]);



// WEBPACK FOOTER //
// ./Common/directivesModule.ts